import moment from 'moment'
import { createStructuredSelector } from 'reselect'
import { branch, renderNothing } from 'recompose'

import { getDateFormat } from 'i18n/utils'
import { getNews } from 'news/actions'
import { loadOnMount } from 'shared/hoc'

import { relatedNewsSelector, categorySelector } from '../selectors'

const RelatedArticles = ({ news }) => (
    <div className="container-fluid related articles">
        <div className="container">
            <div className="row title">
                <div className="col-lg-12">
                    <h2>
                        <T>news.label.related.news</T>
                    </h2>
                </div>
            </div>

            {news.map(({ date, title, categories, slug }, i) => {
                const formattedDate = moment(date).format(getDateFormat())
                const url = `news/uncategorized/${slug}`

                return (
                    <div className="row article" key={i}>
                        <div className="col-lg-12">
                            <span>
                                <i className="category icon-4" />
                                <T>news.label.published</T> {formattedDate}
                            </span>
                        </div>
                        <div className="col-lg-12 title">
                            <h2>
                                <Link to={url} title={title}>
                                    {title}
                                </Link>
                            </h2>
                        </div>
                    </div>
                )
            })}
        </div>
    </div>
)

export default compose(
    connect(
        createStructuredSelector({
            category: categorySelector,
            news: relatedNewsSelector,
        }),
        { getNews }
    ),
    branch(props => !props.category && !props.uncategorized, renderNothing),
    loadOnMount('getNews', ({ category }) => [category])
)(RelatedArticles)
